module.exports = __webpack_public_path__ + "static/media/Bilbao.ce745439.jpg";